import React,{useState} from "react";
import {Modal,Form,Row,Col,Button,Badge} from "react-bootstrap";
import {FiCalendar} from "react-icons/fi";
import {FaImage} from "react-icons/fa";
import {AiOutlineDelete} from "react-icons/ai";
import InsertProjectImageModal from "./InsertProjectImageModal";
import { useRef,  } from "react";

import { FaBold, FaItalic, FaUnderline,  } from "react-icons/fa";
export default function EditTaskModal({show,setShow}){

const[showImage,setShowImage]=useState(false)

const[files,setFiles]=useState([
{name:"Logo.zip",size:"21MB"},
{name:"Files.zip",size:"25MB"}
])

const removeFile=(index)=>{
setFiles(files.filter((f,i)=>i!==index))
}

  const editorRef = useRef();

  const formatText = (command, value = null) => {
    document.execCommand(command, false, value);
  };

  const handleFontSize = (size) => {
    document.execCommand("fontSize", false, "7");
    const fontElements = editorRef.current.getElementsByTagName("font");
    for (let i = 0; i < fontElements.length; i++) {
      if (fontElements[i].size === "7") {
        fontElements[i].removeAttribute("size");
        fontElements[i].style.fontSize = size + "px";
      }
    }
  };

    const [members, setMembers] = useState([
    "Jerald",
    "Andrew",
    "Philip",
    "Davis",
  ]);

  const [inputVisible, setInputVisible] = useState(false);
  const [newMember, setNewMember] = useState("");

  const addMember = () => {
    if (newMember.trim() && !members.includes(newMember)) {
      setMembers([...members, newMember.trim()]);
    }
    setNewMember("");
    setInputVisible(false);
  };
    const removeMember = (name) => {
    setMembers(members.filter((m) => m !== name));
  };
return(

<>

<Modal
show={show}
onHide={()=>setShow(false)}
centered
dialogClassName="edit-task-modal"
>

<Modal.Header closeButton>
<Modal.Title>Edit Task</Modal.Title>
</Modal.Header>


<Modal.Body>

<Form>

{/* Title */}

<Form.Group className="mb-3">

<Form.Label>Todo Title</Form.Label>

<Form.Control
defaultValue="Patient appointment booking"
/>

</Form.Group>


<Row>

{/* Due Date */}

<Col md={6}>

<Form.Group className="mb-3">

<Form.Label>Due Date</Form.Label>

<div className="date-input">

<Form.Control placeholder="dd/mm/yyyy"/>

<FiCalendar className="calendar-icon"/>

</div>

</Form.Group>

</Col>


{/* Project */}

<Col md={6}>

<Form.Group className="mb-3">

<Form.Label>Project</Form.Label>

<Form.Select className="orange-select">

<option>Office Management</option>
<option>Clinic Management</option>
<option>Education Platform</option>

</Form.Select>

</Form.Group>

</Col>

</Row>


{/* Team Members */}
 <Form.Group className="mb-3">
      <Form.Label className="label-text">Team Members</Form.Label>

      <div className="member-box">
        {members.map((member, index) => (
          <span key={index} className="tag">
            {member}
            <span
              className="close"
              onClick={() => removeMember(member)}
            >
              ×
            </span>
          </span>
        ))}

        {inputVisible ? (
          <input
            className="tag-input"
            value={newMember}
            autoFocus
            onChange={(e) => setNewMember(e.target.value)}
            onBlur={addMember}
            onKeyDown={(e) => e.key === "Enter" && addMember()}
          />
        ) : (
          <span
            className="add-new"
            onClick={() => setInputVisible(true)}
          >
            Add new
          </span>
        )}
      </div>
    </Form.Group>


<Row>

{/* Tag */}

<Col md={6}>

<Form.Group className="mb-3">

<Form.Label>Tag</Form.Label>

<Form.Select className="orange-select">

<option>Projects</option>
<option>Internal</option>
<option>Meetings</option>
<option>Reminder</option>

</Form.Select>

</Form.Group>

</Col>


{/* Status */}

<Col md={6}>

<Form.Group className="mb-3">

<Form.Label>Status</Form.Label>

<Form.Select className="orange-select">

<option>Inprogress</option>
<option>Completed</option>
<option>Pending</option>
<option>On Hold</option>

</Form.Select>

</Form.Group>

</Col>

</Row>


{/* Priority */}

<Form.Group className="mb-3">

<Form.Label>Priority</Form.Label>

<Form.Select className="orange-select">

<option>Medium</option>
<option>Low</option>
<option>High</option>

</Form.Select>

</Form.Group>


{/* Visibility */}

<Form.Group className="mb-3">

<Form.Label>Who Can See this Task?</Form.Label>

<div className="radio-group">

<Form.Check type="radio" label="Public" name="visibility"/>

<Form.Check
type="radio"
label="Private"
name="visibility"
defaultChecked
className="orange-radio"
/>

<Form.Check type="radio" label="Admin Only" name="visibility"/>

</div>

</Form.Group>


{/* Description */}
 <Form.Group className="mb-3">
      <Form.Label className="label-text">Descriptions</Form.Label>

      <div className="editor-wrapper">
        {/* Toolbar */}
        <div className="toolbar">
          {/* Font Dropdown */}
          <select
            className="dropdown"
            defaultValue="14"
            onChange={(e) => handleFontSize(e.target.value)}
          >
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="14">14</option>
            <option value="18">18</option>
            <option value="24">24</option>
            <option value="36">36</option>
          </select>

          <button onClick={() => formatText("bold")}><FaBold /></button>
          <button onClick={() => formatText("italic")}><FaItalic /></button>
          <button onClick={() => formatText("underline")}><FaUnderline /></button>
          <button onClick={() => formatText("removeFormat")}>⌫</button>
          <button onClick={() => formatText("strikeThrough")}>S</button>

          <button
            onClick={(e) => {
              e.preventDefault();
              setShowImage(true);
            }}
          >
            <FaImage />
          </button>
        </div>

        {/* Editor */}
        <div
          ref={editorRef}
          className="editor-area"
          contentEditable
          suppressContentEditableWarning={true}
        />
      </div>
    </Form.Group>

{/* Upload Attachment */}

<Form.Group>

<Form.Label>Upload Attachment</Form.Label>

<div className="upload-box">

<input type="file"/>

</div>

<div className="file-list">

{files.map((f,i)=>(

<div key={i} className="file-row">

<span>{f.name}</span>

<Badge bg="primary">{f.size}</Badge>

<AiOutlineDelete
className="delete-icon"
onClick={()=>removeFile(i)}
/>

</div>

))}

</div>

</Form.Group>

</Form>

</Modal.Body>


<Modal.Footer>

<Button
variant="light"
onClick={()=>setShow(false)}
>
Cancel
</Button>

<Button className="save-btn">
Save
</Button>

</Modal.Footer>


<style>{`

.edit-task-modal .modal-dialog{
max-width:720px;
}

.orange-select:focus{
border-color:#f97316;
box-shadow:0 0 0 0.15rem rgba(249,115,22,0.25);
}

.date-input{
position:relative;
}

.calendar-icon{
position:absolute;
right:10px;
top:50%;
transform:translateY(-50%);
color:#6b7280;
}

.member-tags span{
background:#f1f5f9;
padding:4px 8px;
border-radius:4px;
margin-right:5px;
font-size:12px;
}

.add-new{
margin-left:6px;
font-size:13px;
cursor:pointer;
}

.radio-group{
display:flex;
gap:20px;
}

.editor-toolbar{
border:1px solid #ddd;
padding:5px;
display:flex;
gap:6px;
}

.editor-box{
width:100%;
height:120px;
border:1px solid #ddd;
}

.upload-box{
background:#f9fafb;
padding:10px;
border-radius:6px;
margin-bottom:10px;
}

.file-row{
display:flex;
align-items:center;
justify-content:space-between;
padding:6px 0;
}

.delete-icon{
cursor:pointer;
color:#ef4444;
}

.save-btn{
background:#f97316;
border:none;
}

.label-text {
  font-size: 14px;
  font-weight: 500;
  color: #2c2c2c;
}

/* Wrapper */
.editor-wrapper {
  border: 1px solid #d5d5d5;
  border-radius: 6px;
  overflow: hidden;
}

/* Toolbar */
.toolbar {
  display: flex;
  align-items: center;
  padding: 6px;
  background: #f3f3f3;
  border-bottom: 1px solid #d5d5d5;
  gap: 4px;
}

/* Dropdown EXACT style */
.dropdown {
  height: 34px;
  border: 1px solid #cfcfcf;
  background: #fff;
  padding: 4px 28px 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  appearance: none;
  position: relative;
}

/* Buttons EXACT */
.toolbar button {
  height: 34px;
  min-width: 34px;
  border: 1px solid #cfcfcf;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
}

.toolbar button:hover {
  background: #e9e9e9;
}

/* Editor Area */
.editor-area {
  min-height: 180px;
  padding: 12px;
  font-size: 14px;
  outline: none;
}

/* Bottom resize indicator line */
.editor-area::after {
  content: "";
  display: block;
  height: 6px;
  margin-top: 10px;
  border-top: 2px solid #dcdcdc;
  width: 40px;
  margin-left: auto;
  margin-right: auto;
}

// addnew
.label-text {
  font-size: 14px;
  font-weight: 500;
  color: #2c2c2c;
}

/* Container */
.member-box {
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  background: #fff;
}

/* Tag style EXACT */
.tag {
  display: inline-flex;
  align-items: center;
  background: #e9ecef;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  color: #333;
}

/* Close icon */
.tag .close {
  margin-left: 6px;
  cursor: pointer;
  font-size: 14px;
}

/* Add new */
.add-new {
  color: #6c757d;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

/* Input */
.tag-input {
  border: none;
  outline: none;
  font-size: 14px;
  min-width: 100px;
}

/* Mobile */
@media (max-width: 576px) {
  .member-box {
    padding: 8px;
  }

  .tag {
    font-size: 12px;
    padding: 5px 8px;
  }

  .add-new {
    font-size: 13px;
  }
}

/* MOBILE PERFECT */
@media (max-width: 576px) {
  .toolbar {
    flex-wrap: wrap;
  }

  .toolbar button {
    height: 30px;
    min-width: 30px;
  }

  .dropdown {
    height: 30px;
    font-size: 12px;
  }

  .editor-area {
    min-height: 140px;
  }
}
}


`}</style>

</Modal>


<InsertProjectImageModal
show={showImage}
setShow={setShowImage}
/>

</>

)

}